export default __webpack_public_path__ + "images/195989b5dd866bc925dc5c70c34b1a8a.svg";